import React, { useState } from "react";
import Header from "../../components/Header/Header";
import Footer from "../../components/Footer/Footer";
import ContactMap from "./contactMap";
import AboutBreadcrumb from "../../components/AboutPage/AboutBreadcrumb/AboutBreadcrumb";

import {
  FaFacebookF,
  FaLinkedinIn,
  FaInstagram,
  FaTwitter
} from "react-icons/fa";

import "./ContactPage.css";

const ContactPage = () => {
  const [success, setSuccess] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    const formData = new FormData(e.target);

    try {
      const response = await fetch(
        `${process.env.PUBLIC_URL}/contact-mail.php`,
        {
          method: "POST",
          body: formData,
        }
      );

      if (response.ok) {
        setSuccess(true);
        e.target.reset();
      }
    } catch (error) {
      alert("Email works only on live server");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Header />
      <AboutBreadcrumb label="Contact Us" />

      <section className="contact-section">
        {/* LEFT IMAGE */}
        <div className="contact-image">
          <img
            src="assets/images/contact.webp"
            alt="Contact"
          />
        </div>

        {/* RIGHT CONTENT */}
        <div className="contact-content">
          <h2>Contact Us</h2>
          <p>Get in touch with us for any service-related queries.</p>

          {success && (
            <div className="success-msg">
              ✅ Thank you! We will contact you shortly.
            </div>
          )}

          <form className="contact-form" onSubmit={handleSubmit}>
            <input name="name" placeholder="Full Name" required />
            <input name="phone" placeholder="Phone Number" required />
            <input name="email" type="email" placeholder="Email ID" required />

            <select name="service" required>
              <option value="">Select Service</option>
              <option>Oil & Gas</option>
              <option>Pre-Engineered Buildings</option>
              <option>Real Estate</option>
              <option>BIM Services</option>
            </select>

            <button type="submit" disabled={loading}>
              {loading ? "Sending..." : "Submit"}
            </button>
          </form>

          {/* WORKING HOURS + SOCIAL */}
          <div className="contact-bottom">
            <div className="working-hours">
              <h4>Working Hours</h4>
              <p>Monday – Friday: 9:00 AM – 6:00 PM</p>
              <p>Saturday: 10:00 AM – 4:00 PM</p>
              <p>Sunday: Closed</p>
            </div>

            <div className="social-icons">
              <a href="https://www.facebook.com/intelbuildhuzaifa" target="_blank" rel="noreferrer">
                <FaFacebookF />
              </a>
              <a href="https://www.linkedin.com/company/intelbuild-engineering-services-llp/" target="_blank" rel="noreferrer">
                <FaLinkedinIn />
              </a>
              <a href="https://www.instagram.com/" target="_blank" rel="noreferrer">
                <FaInstagram />
              </a>
              <a href="https://www.twitter.com/intelbuildarc" target="_blank" rel="noreferrer">
                <FaTwitter />
              </a>
            </div>
          </div>
        </div>
      </section>

      <ContactMap />
      <Footer />
    </>
  );
};

export default ContactPage;
